import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Radio,
  Dropdown,
  Checkbox,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox,
  TimeFreeTextBox24
} from 'react-lib/apps/common'

const ANES_ANESRecord_01 = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardAnesRecord01"
        style={{ width: "100%", padding:"10px"}}>
        <div
          id="ANES_ANESRecord_01-div-3">
          
          <div
            id="ANES_ANESRecord_01-div-4"
            style={{ gridRow: "1/2", gridColumn: "1/3",marginLeft:"10px",marginTop:"10px", display: "flex", justifyContent: "space-between", marginBottom: "10px", alingItem: "center" }}>
            
            <div
              style={{display: "flex" }}>
              
              <div
                id="ANES_ANESRecord_01-div-5"
                style={{ display: "flex" ,fontWeight:"Bold",fontSize:"18px", alignItems: "center"}}>
                {props.languageUX === "en" ? "Anesthetic Assessment Record" : "บันทึกการประเมินการดมยาสลบ"}
              </div>
              <div
                style={{ marginLeft: "10px"}}>
                {props.buttonPrintDocumant}
              </div>
              <div
                style={{ marginLeft: "10px"}}>
                {props.buttonUploadDocument}
              </div>
              <div
                style={{ marginLeft: "10px"}}>
                {props.buttonViewDocument}
              </div>
            </div>
            <div
              id="ANES_ANESRecord_01-div-182"
              style={{display: "flex" }}>
              
              <div
                id="ANES_ANESRecord_01-div-183">
                {props.buttonLog}
              </div>
              <div
                id="ANES_ANESRecord_01-div-184"
                style={{display: "none"}}>
                {props.buttonPrint}
              </div>
              <div
                id="ANES_ANESRecord_01-div-185"
                style={{ display: props.AnesRecordStatus === "CONFIRMED" ?  "none" : "",}}>
                {props.buttonSave}
              </div>
              <div
                id="ANES_ANESRecord_01-div-186"
                style={{ display: props.AnesRecordStatus === "CONFIRMED" ?  "none" : "",}}>
                {props.buttonConfirm}
              </div>
            </div>
          </div>
        </div>
        <div
          className="--override-disabled --grey"
          id="ANES_ANESRecord_01-div-1"
          style={{backgroundColor: "#EDF6F9",width: "100%",height:"50%",padding:"10px",borderRadius: 3,border : "solid 0.5px ",borderColor:"#5DBCD2", ...(props.isPHV && { pointerEvents: "none" })}}>
          
          <div
            id="ANES_ANESRecord_01-div-6"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(1, 1fr)","gridTemplateColumns":"repeat(40, 1fr)"}}>
            <div
              id="ANES_ANESRecord_01-div-178"
              style={{ gridRow: "6/7", gridColumn: "28/40", display: "none" }}>
              
              <div
                id="ANES_ANESRecord_01-div-179">
                {props.buttonLog}
              </div>
              <div
                id="ANES_ANESRecord_01-div-180">
                {props.buttonPrint}
              </div>
              <div
                id="ANES_ANESRecord_01-div-181">
                {props.buttonSave}
              </div>
            </div>
            <div
              id="ANES_ANESRecord_01-div-189"
              style={{ gridRow: "2/3", gridColumn: "28/31",paddingTop:"5px"}}>
              
              <div
                id="ANES_ANESRecord_01-div-192"
                style={{ width:"100%", height:"100%" , display: "flex" , alignItems:"center"}}>
                
              </div>
            </div>
            <div
              id="ANES_ANESRecord_01-div-190"
              style={{ gridRow: "2/3", gridColumn: "10/13",paddingTop:"5px"}}>
              
              <div
                id="ANES_ANESRecord_01-div-191"
                style={{ width:"100%", height:"100%" , display: "flex" , alignItems:"center"}}>
                
              </div>
            </div>
          </div>
          <Form
            id="ANES_ANESRecord_01-Form-196">
            <FormGroup
              id="ANES_ANESRecord_01-FormGroup-197"
              inline={true}>
              <FormField
                id="ANES_ANESRecord_01-FormField-201"
                inline={true}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-204"
                  style={{minWidth: "105px",maxWidth: "105px"}}>
                  {props.languageUX === "en" ? "Operative Date" : "วันที่ดำเนินการ"}
                </label>
                <div
                  id="ANES_ANESRecord_01-div-253"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    disabled={true}
                    id="ANES_ANESRecord_01-DateTextBox-254"
                    onChange={props.onChangeDateForm}
                    value={props.AnesRecordSequence?.DateRamrk}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-202"
                inline={true}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-205"
                  style={{minWidth: "120px",maxWidth: "120px"}}>
                  {props.languageUX === "en" ? "OR Location" : "หรือตำแหน่งที่ตั้ง"}
                </label>
                <Input
                  disabled={true}
                  id="ANES_ANESRecord_01-Input-208"
                  name="ORRmark"
                  onChange={props.onChangeData}
                  value={props.AnesRecordSequence?.ORRmark}>
                </Input>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-203"
                inline={true}
                width={6}>
                <label
                  id="ANES_ANESRecord_01-label-206"
                  style={{minWidth: "120px",maxWidth: "120px"}}>
                  {props.languageUX === "en" ? "Patient location" : "ตำแหน่งผู้ป่วย"}
                </label>
                <Radio
                  checked={props.AnesRecordSequence?.PatientLocation === "OPD"}
                  id="ANES_ANESRecord_01-Radio-209"
                  label="OPD"
                  name="PatientLocation"
                  onChange={props.onChangeData}
                  style={{minWidth: "max-content"}}
                  value="OPD">
                </Radio>
                <Radio
                  checked={props.AnesRecordSequence?.PatientLocation === "Ward"}
                  id="ANES_ANESRecord_01-Radio-210"
                  label="Ward"
                  name="PatientLocation"
                  onChange={props.onChangeData}
                  style={{marginLeft: "1rem",minWidth: "max-content"}}
                  value="Ward">
                </Radio>
                <Dropdown
                  clearable={true}
                  disabled={props.AnesRecordSequence?.PatientLocation !== "Ward"}
                  fluid={true}
                  id="ANES_ANESRecord_01-Dropdown-211"
                  name="IsWardRemark"
                  onChange={props.onChangeData}
                  options={props.masterOptions?.divisionWard}
                  search={true}
                  selection={true}
                  style={{marginLeft: "1rem", width: "100%"}}
                  value={props.AnesRecordSequence?.PatientLocation === "Ward" ? props.AnesRecordSequence?.IsWardRemark : ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ANES_ANESRecord_01-FormGroup-356"
              inline={true}
              style={{ alignItems: "baseline"  }}>
              <FormField
                id="ANES_ANESRecord_01-FormField-357"
                inline={true}
                style={{ alignItems: "baseline"  }}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-362"
                  style={{minWidth: "105px", maxWidth: "105px"}}>
                  {props.languageUX === "en" ? "Surgical team" : "ทีมศัลยแพทย์"}
                </label>
                <TextArea
                  className="--override-disabled --grey"
                  disabled={true}
                  id="ANES_ANESRecord_01-TextArea-367"
                  name="SurgicalTeam"
                  onChange={props.onChangeData}
                  style={{width: "100%", resize: "none"}}
                  value={props.AnesRecordSequence?.SurgicalTeam}>
                </TextArea>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-358"
                width={5}>
                <div
                  id="ANES_ANESRecord_01-div-388"
                  style={{ width: "100%" }}>
                  
                  <FormField
                    id="ANES_ANESRecord_01-FormField-389"
                    inline={true}
                    style={{ marginBottom: "10px"}}
                    width={16}>
                    <label
                      id="ANES_ANESRecord_01-label-391"
                      style={{minWidth: "130px",maxWidth: "130px"}}>
                      {props.languageUX === "en" ? "Pre-operative Dx" : "การวินิจฉัยก่อนผ่าตัด"}
                    </label>
                    <Input
                      disabled={true}
                      fluid={true}
                      id="ANES_ANESRecord_01-Input-393"
                      style={{ width: "100%" }}
                      value={props.AnesRecordSequence?.PreoperativeDiagnosis}>
                    </Input>
                  </FormField>
                  <FormField
                    id="ANES_ANESRecord_01-FormField-390"
                    inline={true}
                    width={16}>
                    <label
                      id="ANES_ANESRecord_01-label-392"
                      style={{minWidth: "130px",maxWidth: "130px"}}>
                      {props.languageUX === "en" ? "Proposed operation" : "การดำเนินการที่เสนอ"}
                    </label>
                    <Input
                      disabled={true}
                      fluid={true}
                      id="ANES_ANESRecord_01-Input-394"
                      style={{width: "100%"}}
                      value={props.AnesRecordSequence?.ProposedOperation}>
                    </Input>
                  </FormField>
                </div>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-359"
                inline={true}
                style={{ alignItems: "baseline"  }}
                width={6}>
                <div
                  id="ANES_ANESRecord_01-div-395"
                  style={{ width: "100%" }}>
                  
                  <FormField
                    id="ANES_ANESRecord_01-FormField-396"
                    inline={true}
                    style={{ marginBottom: "10px"}}
                    width={16}>
                    <label
                      id="ANES_ANESRecord_01-label-398"
                      style={{minWidth: "130px",maxWidth: "130px"}}>
                      {props.languageUX === "en" ? "Post-operative Dx" : "การวินิจฉัยหลังผ่าตัด"}
                    </label>
                    <Input
                      disabled={true}
                      fluid={true}
                      id="ANES_ANESRecord_01-Input-400"
                      style={{ width: "100%" }}
                      value={props.AnesRecordSequence?.PostoperativeDiagnosis}>
                    </Input>
                  </FormField>
                  <FormField
                    id="ANES_ANESRecord_01-FormField-397"
                    inline={true}
                    width={16}>
                    <label
                      id="ANES_ANESRecord_01-label-399"
                      style={{minWidth: "130px",maxWidth: "130px"}}>
                      {props.languageUX === "en" ? "Performed operation" : "ดำเนินการแล้ว"}
                    </label>
                    <Input
                      disabled={true}
                      fluid={true}
                      id="ANES_ANESRecord_01-Input-401"
                      style={{width: "100%"}}
                      value={props.AnesRecordSequence?.PerformedOperation}>
                    </Input>
                  </FormField>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ANES_ANESRecord_01-FormGroup-256"
              inline={true}>
              <FormField
                id="ANES_ANESRecord_01-FormField-258"
                inline={true}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-265"
                  style={{minWidth: "105px", maxWidth: "105px"}}>
                  {props.languageUX === "en" ? "Start Anes." : "เริ่มต้น Anes"}
                </label>
                <div
                  id="ANES_ANESRecord_01-div-372"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="ANES_ANESRecord_01-DateTextBox-374"
                    onChange={props.onChangeStartDate}
                    value={props.AnesRecordSequence?.StartAnesDate}>
                  </DateTextBox>
                </div>
                <div
                  id="ANES_ANESRecord_01-div-281"
                  style={{width: "fit-content"}}>
                  
                  <TimeFreeTextBox24
                    className="time-custom-react-picker"
                    id="ANES_ANESRecord_01-TimeFreeTextBox24-282"
                    onChange={props.onChangeStartAnesTime}
                    value={props.AnesRecordSequence?.StartAnesTime}>
                  </TimeFreeTextBox24>
                </div>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-260"
                inline={true}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-273"
                  style={{minWidth: "105px", maxWidth: "105px"}}>
                  {props.languageUX === "en" ? "End Anes." : "ปลายอเนส"}
                </label>
                <div
                  id="ANES_ANESRecord_01-div-373"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="ANES_ANESRecord_01-DateTextBox-375"
                    onChange={props.onChangeEndDate}
                    value={props.AnesRecordSequence?.EndAnesDate}>
                  </DateTextBox>
                </div>
                <div
                  id="ANES_ANESRecord_01-div-283"
                  style={{width: "fit-content"}}>
                  
                  <TimeFreeTextBox24
                    className="time-custom-react-picker"
                    id="ANES_ANESRecord_01-TimeFreeTextBox24-284"
                    onChange={props.onChangeEndAnesTime}
                    value={props.AnesRecordSequence?.EndAnesTime}>
                  </TimeFreeTextBox24>
                </div>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-285"
                inline="true">
                <Checkbox
                  checked={props.AnesRecordSequence?.startAfterClinic}
                  id="ANES_ANESRecord_01-Checkbox-286"
                  label={props.languageUX === "en" ? "Part-time" : "นอกเวลา"}
                  name="startAfterClinic"
                  onChange={props.onChangeData}
                  style={{marginLeft: "0.5rem", minWidth: "6rem"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-264"
                inline={true}
                style={{padding: 0}}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-275"
                  style={{width: "fit-content"}}>
                  {props.languageUX === "en" ? "Total Anesthetic time" : "เวลาการดมยาสลบทั้งหมด"}
                </label>
                <Input
                  disabled={true}
                  id="ANES_ANESRecord_01-Input-279"
                  style={{ width: "20%" }}
                  value={props.AnesRecordSequence?.TotalAnseTimeHour || 0}>
                </Input>
                <label
                  id="ANES_ANESRecord_01-label-277"
                  style={{margin: "0px 1rem"}}>
                  {props.languageUX === "en" ? "hr(s)" : "ชั่วโมง"}
                </label>
                <Input
                  disabled={true}
                  id="ANES_ANESRecord_01-Input-280"
                  style={{ width: "20%" }}
                  value={props.AnesRecordSequence?.TotalAnseTimeMinute || 0}>
                </Input>
                <label
                  id="ANES_ANESRecord_01-label-278"
                  style={{marginLeft: "1rem"}}>
                  {props.languageUX === "en" ? "min" : "นาที"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ANES_ANESRecord_01-FormGroup-257"
              inline={true}
              style={{ alignItems: "flex-start" }}>
              <FormField
                id="ANES_ANESRecord_01-FormField-287"
                inline={true}
                style={{ alignItems: "center" }}
                width={5}>
                <label
                  id="ANES_ANESRecord_01-label-289"
                  style={{minWidth: "95px", maxWidth: "95px"}}>
                  {props.languageUX === "en" ? "Anesthesiologist" : "วิสัญญีแพทย์"}
                </label>
                <Dropdown
                  id="ANES_ANESRecord_01-Dropdown-292"
                  name="Anesthesiologist"
                  onChange={props.onChangeData}
                  options={props.masterOptions.doctor || []}
                  selection={true}
                  style={{width: "100%", display: "none"}}
                  value={props.AnesRecordSequence?.Anesthesiologist || ""}>
                </Dropdown>
                <div
                  id="ANES_ANESRecord_01-div-344"
                  style={{ width: "100%" }}>
                  {props.SurgeonElement}
                </div>
              </FormField>
              <FormField
                id="ANES_ANESRecord_01-FormField-288"
                inline={true}
                style={{ alignItems: "flex-start" }}
                width={11}>
                <label
                  id="ANES_ANESRecord_01-label-290"
                  style={{minWidth: "115px", maxWidth: "115px", marginTop: "7px"}}>
                  {props.languageUX === "en" ? "Anesthesia nurse" : "พยาบาลวิสัญญี"}
                </label>
                <div
                  id="ANES_ANESRecord_01-div-343"
                  style={{ width: "100%" }}>
                  {props.AnesthetistElement}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default ANES_ANESRecord_01

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesRecord01"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-1"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#EDF6F9\",width: \"100%\",height:\"50%\",padding:\"10px\",borderRadius: 3,border : \"solid 0.5px \",borderColor:\"#5DBCD2\", ...(props.isPHV && { pointerEvents: \"none\" })}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-3"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/3\",marginLeft:\"10px\",marginTop:\"10px\", display: \"flex\", justifyContent: \"space-between\", marginBottom: \"10px\", alingItem: \"center\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "label": "divgrid",
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-6"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(1, 1fr)\",\"gridTemplateColumns\":\"repeat(40, 1fr)\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-178"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"28/40\", display: \"none\" }"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonLog"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-179"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-180"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-181"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-182"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" }"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonLog"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-184"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-185"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.AnesRecordStatus === \"CONFIRMED\" ?  \"none\" : \"\",}"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-186"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.AnesRecordStatus === \"CONFIRMED\" ?  \"none\" : \"\",}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-189"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"28/31\",paddingTop:\"5px\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-190"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/3\", gridColumn: \"10/13\",paddingTop:\"5px\"}"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 190,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-191"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\", height:\"100%\" , display: \"flex\" , alignItems:\"center\"}"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-192"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\", height:\"100%\" , display: \"flex\" , alignItems:\"center\"}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Form-196"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormGroup",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormGroup-197"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "FormField",
      "parent": 197,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-201"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "FormField",
      "parent": 197,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-202"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "FormField",
      "parent": 197,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-203"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 204,
      "name": "label",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ดำเนินการ",
          "valueEN": "Operative Date"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-204"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\",maxWidth: \"105px\"}"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "label",
      "parent": 202,
      "props": {
        "children": {
          "type": "value",
          "value": "หรือตำแหน่งที่ตั้ง",
          "valueEN": "OR Location"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-205"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\",maxWidth: \"120px\"}"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": null,
      "id": 206,
      "name": "label",
      "parent": 203,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่งผู้ป่วย",
          "valueEN": "Patient location"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-206"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\",maxWidth: \"120px\"}"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "Input",
      "parent": 202,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-208"
        },
        "name": {
          "type": "value",
          "value": "ORRmark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.ORRmark"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 209,
      "name": "Radio",
      "parent": 203,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PatientLocation === \"OPD\""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Radio-209"
        },
        "label": {
          "type": "value",
          "value": "OPD"
        },
        "name": {
          "type": "value",
          "value": "PatientLocation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "value": {
          "type": "value",
          "value": "OPD"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "Radio",
      "parent": 203,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PatientLocation === \"Ward\""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Radio-210"
        },
        "label": {
          "type": "value",
          "value": "Ward"
        },
        "name": {
          "type": "value",
          "value": "PatientLocation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\",minWidth: \"max-content\"}"
        },
        "value": {
          "type": "value",
          "value": "Ward"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "Dropdown",
      "parent": 203,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PatientLocation !== \"Ward\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Dropdown-211"
        },
        "name": {
          "type": "value",
          "value": "IsWardRemark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.divisionWard"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PatientLocation === \"Ward\" ? props.AnesRecordSequence?.IsWardRemark : \"\""
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-253"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 254,
      "name": "DateTextBox",
      "parent": 253,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-DateTextBox-254"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateForm"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.DateRamrk"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "FormGroup",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormGroup-256"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "FormGroup",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormGroup-257"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "FormField",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-258"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 260,
      "name": "FormField",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-260"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "FormField",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-264"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 345,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "label",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": "เริ่มต้น Anes",
          "valueEN": "Start Anes."
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-265"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\", maxWidth: \"105px\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "label",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": "ปลายอเนส",
          "valueEN": "End Anes."
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-273"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\", maxWidth: \"105px\"}"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "label",
      "parent": 264,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาการดมยาสลบทั้งหมด",
          "valueEN": "Total Anesthetic time"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-275"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\"}"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "label",
      "parent": 264,
      "props": {
        "children": {
          "type": "value",
          "value": "ชั่วโมง",
          "valueEN": "hr(s)"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-277"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 1rem\"}"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "label",
      "parent": 264,
      "props": {
        "children": {
          "type": "value",
          "value": "นาที",
          "valueEN": "min"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-278"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "Input",
      "parent": 264,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-279"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.TotalAnseTimeHour || 0"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "Input",
      "parent": 264,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-280"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.TotalAnseTimeMinute || 0"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-281"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\"}"
        }
      },
      "seq": 372,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 282,
      "name": "TimeFreeTextBox24",
      "parent": 281,
      "props": {
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-TimeFreeTextBox24-282"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartAnesTime"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.StartAnesTime"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": null,
      "id": 283,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-283"
        },
        "style": {
          "type": "code",
          "value": "{width: \"fit-content\"}"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 284,
      "name": "TimeFreeTextBox24",
      "parent": 283,
      "props": {
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-TimeFreeTextBox24-284"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndAnesTime"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.EndAnesTime"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "FormField",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-285"
        },
        "inline": {
          "type": "value",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 286,
      "name": "Checkbox",
      "parent": 285,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.AnesRecordSequence?.startAfterClinic"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Checkbox-286"
        },
        "label": {
          "type": "value",
          "value": "นอกเวลา",
          "valueEN": "Part-time"
        },
        "name": {
          "type": "value",
          "value": "startAfterClinic"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.5rem\", minWidth: \"6rem\"}"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 287,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-287"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 288,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-288"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "label",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": "วิสัญญีแพทย์",
          "valueEN": "Anesthesiologist"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-289"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "label",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลวิสัญญี",
          "valueEN": "Anesthesia nurse"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-290"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"115px\", maxWidth: \"115px\", marginTop: \"7px\"}"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 292,
      "name": "Dropdown",
      "parent": 287,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Dropdown-292"
        },
        "name": {
          "type": "value",
          "value": "Anesthesiologist"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions.doctor || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.Anesthesiologist || \"\""
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 343,
      "name": "div",
      "parent": 288,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AnesthetistElement"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-343"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": null,
      "id": 344,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SurgeonElement"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-344"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 356,
      "name": "FormGroup",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormGroup-356"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"baseline\"  }"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 357,
      "name": "FormField",
      "parent": 356,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-357"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"baseline\"  }"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 357,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 358,
      "name": "FormField",
      "parent": 356,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-358"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 358,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 359,
      "name": "FormField",
      "parent": 356,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-359"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"baseline\"  }"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": null,
      "id": 362,
      "name": "label",
      "parent": 357,
      "props": {
        "children": {
          "type": "value",
          "value": "ทีมศัลยแพทย์",
          "valueEN": "Surgical team"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-362"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\", maxWidth: \"105px\"}"
        }
      },
      "seq": 362,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 367,
      "name": "TextArea",
      "parent": 357,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-TextArea-367"
        },
        "name": {
          "type": "value",
          "value": "SurgicalTeam"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.SurgicalTeam"
        }
      },
      "seq": 367,
      "void": true
    },
    {
      "from": null,
      "id": 372,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-372"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 373,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-373"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 374,
      "name": "DateTextBox",
      "parent": 372,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-DateTextBox-374"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.StartAnesDate"
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 375,
      "name": "DateTextBox",
      "parent": 373,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-DateTextBox-375"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.EndAnesDate"
        }
      },
      "seq": 375,
      "void": false
    },
    {
      "from": null,
      "id": 388,
      "name": "div",
      "parent": 358,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-388"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 389,
      "name": "FormField",
      "parent": 388,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-389"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"10px\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 390,
      "name": "FormField",
      "parent": 388,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-390"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": null,
      "id": 391,
      "name": "label",
      "parent": 389,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยก่อนผ่าตัด",
          "valueEN": "Pre-operative Dx"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-391"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"130px\",maxWidth: \"130px\"}"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": null,
      "id": 392,
      "name": "label",
      "parent": 390,
      "props": {
        "children": {
          "type": "value",
          "value": "การดำเนินการที่เสนอ",
          "valueEN": "Proposed operation"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-392"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"130px\",maxWidth: \"130px\"}"
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 393,
      "name": "Input",
      "parent": 389,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-393"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PreoperativeDiagnosis"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 394,
      "name": "Input",
      "parent": 390,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-394"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.ProposedOperation"
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": null,
      "id": 395,
      "name": "div",
      "parent": 359,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-395"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 396,
      "name": "FormField",
      "parent": 395,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-396"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"10px\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 397,
      "name": "FormField",
      "parent": 395,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-FormField-397"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": null,
      "id": 398,
      "name": "label",
      "parent": 396,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยหลังผ่าตัด",
          "valueEN": "Post-operative Dx"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-398"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"130px\",maxWidth: \"130px\"}"
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": null,
      "id": 399,
      "name": "label",
      "parent": 397,
      "props": {
        "children": {
          "type": "value",
          "value": "ดำเนินการแล้ว",
          "valueEN": "Performed operation"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-label-399"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"130px\",maxWidth: \"130px\"}"
        }
      },
      "seq": 399,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 400,
      "name": "Input",
      "parent": 396,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-400"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PostoperativeDiagnosis"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 401,
      "name": "Input",
      "parent": 397,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-Input-401"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.AnesRecordSequence?.PerformedOperation"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": null,
      "id": 402,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกการประเมินการดมยาสลบ",
          "valueEN": "Anesthetic Assessment Record"
        },
        "id": {
          "type": "value",
          "value": "ANES_ANESRecord_01-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" ,fontWeight:\"Bold\",fontSize:\"18px\", alignItems: \"center\"}"
        }
      },
      "seq": 402,
      "void": false
    },
    {
      "from": null,
      "id": 403,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintDocumant"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\"}"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": null,
      "id": 404,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUploadDocument"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\"}"
        }
      },
      "seq": 404,
      "void": false
    },
    {
      "from": null,
      "id": 405,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonViewDocument"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\"}"
        }
      },
      "seq": 405,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "ANES_ANESRecord_01",
  "project": "IsHealth_by_Front-end",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
